import styled from 'styled-components';
import React, { useState, useEffect, useRef } from "react";
import Slide from "./slide.js";
function Wait_page (){
    return (
      <Category_wrapper>
          <Item_wrapper>
          <Span_div>
            <Content_span>
              현재 페이지는 사용하실 수 없습니다. 
            </Content_span>
            <Content_span2>
            </Content_span2>
          </Span_div>
        <Category_list_ul>
          <Category_list_li>
            <Item_content_wrapper>
                <Item_span_title>
                    준비중
                </Item_span_title>
                <Item_content>
                </Item_content>
            </Item_content_wrapper>
          </Category_list_li>
        </Category_list_ul>
        </Item_wrapper>
      </Category_wrapper>
    )
  }
  const Item_wrapper = styled.div`
  width : 880px;
  margin : 70px auto;
  `
  const Item_content_wrapper = styled.div`
    padding : 5px 10px;
    text-align : left;
  `
  const Item_span_title = styled.div`
    font-weight : bold;
    font-size : 15px;
    text-align : center;
    padding : 10px 5px ;
  `
  const Item_content = styled.div`
    font-size : 10px;
    text-align : center;
    padding : 0 5px ;
  `
  const Item_img = styled.img`
    width : 130px;
    height :130px; 
    margin : 20px;
    border-radius : 100%;
  `
  const Category_wrapper = styled.div`
    width : 1200px;
    overflow : hidden;
    margin : 0px auto;
    padding : 50px 0;
    font-family: "En";        

    `
  const Category_list_ul=styled.ul`
  font-family: "Ko";        

  `
  const Category_list_li = styled.li`
    display : block;
    width : 170px;
    height :45px;
    text-align : center;
    vertical-align : top;
    background: white;
    margin : 0 auto;
    `
  const Content_span = styled.span`
  font-family: "En";        
    display : block;
    font-size : 35px; 
    font-weight : bold; 
    width : 750px;
    box-sizing : border-box  ;
  `
  const Content_span2 = styled.span`
  display : inline-block;
  font-size : 20px; 
  margin: 20px 0; 
  height : 30px;
  `
  const Span_div = styled.div`
    width : 750px;
    text-align : left; 
  `
  
  export default Wait_page;